import jwt_decode from "jwt-decode"
import {getAccessToken} from "../services/AuthServices"

const parseToken = () => {
    const token = getAccessToken()

    if (token.indexOf("ticket") !== -1) {
        return {sub: "dong_nguyen"}
    } else {
        if (!!token) {
            return jwt_decode(token)
        }
    }

    return {}
}

export default parseToken
